import { makeAutoObservable } from "mobx";
export class RadioFieldControler {
    constructor(params) {
        var _a, _b;
        this._value = (_a = params.initialValue) !== null && _a !== void 0 ? _a : null;
        this._touched = false;
        this.update = params.update;
        this.options = (_b = params.options) !== null && _b !== void 0 ? _b : [];
        makeAutoObservable(this);
    }
    onChange(value) {
        this._value = value;
        this.update(value);
    }
    onBlur() {
        this._touched = true;
    }
    get value() {
        return this._value;
    }
    get touched() {
        return this._touched;
    }
    get props() {
        return {
            value: this.value,
            onChange: this.onChange.bind(this),
            onBlur: this.onBlur.bind(this),
        };
    }
}
